import { UserModel } from 'shared';
import { UnknownError } from 'symbols';


export class LoadCurrentUser {
  static type = '[profile] LoadCurrentUser';

  constructor() {
  }
}


export class LoadCurrentUserSuccess {
  static type = '[profile] LoadCurrentUserSuccess';

  constructor(public currentUser: UserModel) {
  }
}


export class LoadCurrentUserFail {
  static type = '[profile] LoadCurrentUserFail';

  constructor(public error: UnknownError) {
  }
}

export class UpdateProfile {
  static type = '[profile] UpdateProfile';

  constructor(public user: Partial<UserModel>) {
  }
}

export class UpdateProfileSuccess {
  static type = '[profile] UpdateProfileSuccess';

  constructor(public user: UserModel) {
  }
}

export class UpdateProfileFail {
  static type = '[profile] UpdateProfileFail';

  constructor(public error: UnknownError) {
  }
}
